import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import './i18n/i18n'; // Importe la configuration i18n
import { Toaster } from 'react-hot-toast';
import ReactGA from 'react-ga4';

// Initialisation de Google Analytics - Remplace G-XXXXXXXX par ton ID de mesure
ReactGA.initialize('G-929FXMMWM1');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <Toaster position="top-center" />
  </React.StrictMode>,
)
